export const getDefaultPolygon = (map: naver.maps.Map) => ({
  map,
  paths: [],
  fillColor: "#CFE7FF",
  fillOpacity: 0.3,
  strokeColor: "#ff0000",
  strokeOpacity: 0.6,
  strokeWeight: 3,
});
